import type { SharedUiPaginatorIntlService } from '@/shared/ui/paginator';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedUiPaginatorIntlServiceAdapter implements SharedUiPaginatorIntlService {
    private _translateService = inject(TranslateService);

    itemsPerPageLabel$: Observable<string> = this._translateService.stream('MAT_TABLE.PAGINATOR.ITEMS_PER_PAGE');
    nextPageLabel$: Observable<string> = this._translateService.stream('MAT_TABLE.PAGINATOR.NEXT_PAGE');
    previousPageLabel$: Observable<string> = this._translateService.stream('MAT_TABLE.PAGINATOR.PREVIOUS_PAGE');
    firstPageLabel$: Observable<string> = this._translateService.stream('MAT_TABLE.PAGINATOR.FIRST_PAGE');
    lastPageLabel$: Observable<string> = this._translateService.stream('MAT_TABLE.PAGINATOR.LAST_PAGE');

    getRangeLabel(page: number, pageSize: number, length: number) {
        return this._translateService.instant('MAT_TABLE.PAGINATOR.RANGE', {
            start: page * pageSize + 1,
            end: page * pageSize + pageSize,
            total: length
        });
    }
}
